import { render, staticRenderFns } from "./haveCar.vue?vue&type=template&id=0510e038&scoped=true&"
import script from "./haveCar.vue?vue&type=script&lang=js&"
export * from "./haveCar.vue?vue&type=script&lang=js&"
import style0 from "./haveCar.vue?vue&type=style&index=0&id=0510e038&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0510e038",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0510e038')) {
      api.createRecord('0510e038', component.options)
    } else {
      api.reload('0510e038', component.options)
    }
    module.hot.accept("./haveCar.vue?vue&type=template&id=0510e038&scoped=true&", function () {
      api.rerender('0510e038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/client/haveCar/haveCar.vue"
export default component.exports